<template>
    <div class="profile-card">
		<div class="picture">
			
			<div class="avatar" v-if="loggedPharmacy.picture" :style="'background-image:url('+API_URL+loggedPharmacy.picture.urlThumb+')'">
			</div>
            <div class="avatar" v-else :style="'background-image:url('+require('@/assets/img/no-avatar-image.gif')+')'">
			</div>
		</div>
		<div class="data">
			
			<h2>{{loggedPharmacy.name}} {{loggedPharmacy.lastname}}</h2>
			<div>
				<!-- {{loggedPharmacy.email}} -->
			</div>
		</div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'ProfileCard',
	computed: {
		...mapGetters(['loggedPharmacy'])
	},
	data(){
        return {
            API_URL: process.env.VUE_APP_API_URL,
        }
    },
}
</script>

<style scoped>

.profile-card{
	display:flex;
	text-align:center;
	flex-direction:column;
	align-items:center;
	padding: 16px;
	z-index: 1000;
}
.picture{
	flex-grow: 0;
	flex-shrink: 0;
	width: 64px;
    height: 64px;
    background-color: #ccc;
    border-radius: 45px;
    display: inline-block;
	margin: 0px 0px;
	border: 2px solid #fff;
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
}
.profile-card .data{
	padding: 8px;
	text-align: left;
	display:flex;
	flex-direction: column;
}
h2{
	color: #000;
	font-size: 15px;
	margin:0px;
}
p{
	color: #000;
	font-size: 12px;
	font-weight: 400;
}

@media (max-width: 991px) {
	.profile-card {
		padding: 8px;
	}
	.picture{
		width: 48px;
		height: 48px;
		margin: 8px 0px 0px 0px;
	}

	.profile-card .data{
		display: none;
	}
}
.profile-card .avatar{
	width: 100%;
	height: 100%;
	position: relative;
}


</style>
